import { render, staticRenderFns } from "./User.vue?vue&type=template&id=089a4ba5&scoped=true&"
import script from "./User.vue?vue&type=script&lang=ts&"
export * from "./User.vue?vue&type=script&lang=ts&"
import style0 from "./User.vue?vue&type=style&index=0&id=089a4ba5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089a4ba5",
  null
  
)

export default component.exports